import { useLanguage } from "@/contexts/LanguageContext";
import { useAboutContent } from "@/hooks/useAboutContent";
import { icons, Award, type LucideIcon } from "lucide-react";

const COPY = {
  lv: { eyebrow: "Mūsu sasniegumi", title: "Skaitļi, kas mūs raksturo" },
  en: { eyebrow: "Our achievements", title: "The numbers behind HAUS" },
  ru: { eyebrow: "Наши достижения", title: "Цифры, которые нас характеризуют" },
} as const;

export function Achievements() {
  const { language } = useLanguage();
  const { stats } = useAboutContent();
  const copy = COPY[(language as keyof typeof COPY)] || COPY.en;

  if (stats.length === 0) return null;

  const label = (s: (typeof stats)[number]) =>
    (language === "lv" ? s.label_lv : language === "ru" ? s.label_ru : s.label_en) ||
    s.label_en ||
    s.label_lv ||
    "";

  return (
    <section className="py-20 bg-charcoal text-cream">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <p className="text-xs tracking-[0.3em] uppercase text-gold font-body mb-3">{copy.eyebrow}</p>
          <h2 className="text-3xl md:text-4xl font-display">{copy.title}</h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 max-w-5xl mx-auto">
          {stats.map((s) => {
            const Icon: LucideIcon = (icons as Record<string, LucideIcon>)[s.icon] || Award;
            return (
              <div key={s.id} className="text-center">
                <Icon className="h-8 w-8 mx-auto mb-4 text-gold" strokeWidth={1.5} />
                <div className="text-4xl md:text-5xl font-display text-cream mb-2">{s.value}</div>
                <p className="text-sm text-cream/60 font-body leading-snug">{label(s)}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
